module.exports = __webpack_public_path__ + "img/guirlande.76ee65a.png";